import API from "../helpers/API"

const PopupController = {
  fetchAll() {
    return API.request("/v1/popup/all", { withStatus: true }, "GET")
  },
}

export default PopupController
